import type { NotificationSettingsItem } from "../types/notification.types"

export const CHANNEL_KEYS: (keyof NotificationSettingsItem)[] = [
  "email",
  "in_app",
  "phone",
  "desktop"
]

// Finance alerts must keep at least one delivery channel enabled; see the
// enabledCount invariant in NotificationSettingsForm.
export const CRITICAL_GROUPS = ["PAYMENTS", "INVOICES"]
